/**
 * Derived measurement computation.
 *
 * Evaluates a derived measurement by resolving its dependencies
 * and calling the template-defined compute function.
 */

import type { MeasurementResult } from '../measurement-result';
import type { IDerivedMeasurementDef } from '../templates/types';

/**
 * Compute a derived measurement from its dependencies.
 *
 * @returns The computed value, or null if any dependency is missing.
 */
export function computeDerived(
    def: IDerivedMeasurementDef,
    resolvedMeasurements: ReadonlyMap<string, MeasurementResult>
): number | null {
    const depValues: Record<string, number> = {};

    for (const depId of def.dependencies) {
        const dep = resolvedMeasurements.get(depId);
        if (!dep) return null;
        depValues[depId] = dep.value;
    }

    try {
        return def.compute(depValues);
    } catch {
        return null;
    }
}
